"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PixelImage_1 = require("../model/PixelImage");
const GraphicMode_1 = require("../model/GraphicMode");
class GraphicModes {
    static createMulticolorFLI() {
        const gm = new GraphicMode_1.default('fli', 160, 200);
        gm.pixelWidth = 2;
        gm.fliBugSize = 3 * 4;
        gm.indexMap = {
            0: 0,
            1: 3,
            2: 2,
            3: 1
        };
        const result = new PixelImage_1.default(gm);
        result.addColorMap();
        result.addColorMap(4, 8);
        result.addColorMap(4, 1);
        result.addColorMap(4, 1);
        return result;
    }
    static createHiresFLI() {
        const gm = new GraphicMode_1.default('fli', 320, 200);
        gm.fliBugSize = 3 * 8;
        const result = new PixelImage_1.default(gm);
        result.addColorMap(8, 1);
        result.addColorMap(8, 1);
        return result;
    }
}
exports.default = GraphicModes;
GraphicModes.bitmap = (props) => {
    const { hires, nomaps } = props;
    const width = hires ? 320 : 160;
    const gm = new GraphicMode_1.default('bitmap', width, 200);
    gm.pixelWidth = hires ? 1 : 2;
    const result = new PixelImage_1.default(gm);
    if (!hires) {
        result.addColorMap();
    }
    if (nomaps) {
        result.addColorMap();
        result.addColorMap();
        if (!hires) {
            result.addColorMap();
        }
    }
    else {
        result.addColorMap(gm.pixelsPerByte(), gm.rowsPerCell);
        result.addColorMap(gm.pixelsPerByte(), gm.rowsPerCell);
        if (!hires) {
            result.addColorMap(gm.pixelsPerByte(), gm.rowsPerCell);
        }
    }
    return result;
};
GraphicModes.c64FLI = (props) => {
    if (props.hires) {
        return GraphicModes.createHiresFLI();
    }
    return GraphicModes.createMulticolorFLI();
};
GraphicModes.c64Sprites = (props) => {
    const { rows, columns, hires, nomaps } = props;
    const nrRows = Number(rows);
    const nrColumns = Number(columns);
    const pixelsPerColumn = hires ? 24 : 12;
    const height = nrRows * 21;
    const width = nrColumns * pixelsPerColumn;
    const gm = new GraphicMode_1.default('sprites', width, height);
    gm.pixelWidth = hires ? 1 : 2;
    gm.bytesPerCellRow = 3;
    gm.rowsPerCell = 21;
    gm.indexMap = {
        0: 0,
        1: 1,
        2: 3,
        3: 2
    };
    const result = new PixelImage_1.default(gm);
    result.addColorMap();
    if (!hires) {
        result.addColorMap();
        result.addColorMap();
    }
    if (nomaps) {
        result.addColorMap();
    }
    else {
        result.addColorMap(pixelsPerColumn, 21);
    }
    return result;
};
GraphicModes.all = {
    bitmap: GraphicModes.bitmap,
    fli: GraphicModes.c64FLI,
    sprites: GraphicModes.c64Sprites
};
//# sourceMappingURL=GraphicModes.js.map